import { request } from "../client";

import type {
  LimitStatus,
  LimitCheckResponse,
  RecordShadowingSessionRequest,
  AllLimitsResponse,
  RecordShadowingSessionResponse,
} from "../types/limits";

export function createLimitsEndpoints(baseUrl: string): {
  getShadowingDailyLimit: (token?: string | null, textId?: string) => Promise<LimitStatus>;
  checkShadowingLimit: (token?: string | null) => Promise<LimitCheckResponse>;
  recordShadowingSession: (
    payload: RecordShadowingSessionRequest,
    token?: string | null,
  ) => Promise<RecordShadowingSessionResponse>;
  getAllLimits: (token?: string | null) => Promise<AllLimitsResponse>;
} {
  return {
    /**
     * Get current shadowing daily limit status
     */
    getShadowingDailyLimit(token?: string | null, textId?: string): Promise<LimitStatus> {
      return request<LimitStatus>(baseUrl, "/limits/shadowing-daily", {
        method: "GET",
        token,
        query: { textId },
      });
    },

    /**
     * Check if shadowing session is allowed
     */
    checkShadowingLimit(token?: string | null): Promise<LimitCheckResponse> {
      return request<LimitCheckResponse>(
        baseUrl,
        "/limits/shadowing-daily/check",
        {
          method: "POST",
          token,
        },
      );
    },

    /**
     * Record shadowing session usage
     */
    recordShadowingSession(
      payload: RecordShadowingSessionRequest,
      token?: string | null,
    ): Promise<RecordShadowingSessionResponse> {
      return request<RecordShadowingSessionResponse>(
        baseUrl,
        "/limits/shadowing-daily/record",
        {
          method: "POST",
          body: payload,
          token,
        },
      );
    },

    /**
     * Get all user limits
     */
    getAllLimits(token?: string | null): Promise<AllLimitsResponse> {
      return request<AllLimitsResponse>(baseUrl, "/limits/all", {
        method: "GET",
        token,
      });
    },
  };
}
